import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  manageUserList: { loading: false, data: null, error: null },
  createmanageUser: { loading: false, data: null, error: null },
  updatemanageUser: { loading: false, data: null, error: null },
  deletemanageUser: { loading: false, data: null, error: null },
  updatemanageUserDetails: { loading: false, data: null, error: null },
  getUserDetails: { loading: false, data: null, error: null },
  usersByRoleList: { loading: false, data: null, error: null },
};

export const manageUser = createSlice({
  name: "manageUser",
  initialState,
  reducers: {
    fetchmanageUserRequest: (manageUser, action) => {
      manageUser.manageUserList.loading = true;
      manageUser.manageUserList.error = null;
    },
    fetchmanageUserSuccess: (manageUser, action) => {
      manageUser.manageUserList.data = action.payload;
      manageUser.manageUserList.loading = false;
      manageUser.manageUserList.error = null;
    },
    fetchmanageUserFailure: (manageUser, action) => {
      manageUser.manageUserList.data = null;
      manageUser.manageUserList.loading = false;
      manageUser.manageUserList.error = action.payload;
    },
    createmanageUserRequest: (manageUser, action) => {
      manageUser.createmanageUser.loading = true;
      manageUser.createmanageUser.error = null;
    },
    createmanageUserSuccess: (manageUser, action) => {
      manageUser.createmanageUser.data = action.payload;
      manageUser.createmanageUser.loading = false;
      manageUser.createmanageUser.error = null;
      manageUser.manageUserList = addNewUserSuccess(action.payload, {
        ...manageUser.manageUserList,
      });
    },
    createmanageUserFailure: (manageUser, action) => {
      manageUser.createmanageUser.data = null;
      manageUser.createmanageUser.loading = false;
      manageUser.createmanageUser.error = action.payload;
    },
    updatemanageUserRequest: (manageUser, action) => {
      manageUser.updatemanageUser.loading = true;
      manageUser.updatemanageUser.error = null;
    },
    updatemanageUserSuccess: (manageUser, action) => {
      manageUser.updatemanageUser.data = action.payload;
      manageUser.updatemanageUser.loading = false;
      manageUser.updatemanageUser.error = null;

      manageUser.manageUserList = updateUserSuccess(
        action.payload,
        manageUser.manageUserList
      );
    },
    updatemanageUserFaliure: (manageUser, action) => {
      manageUser.updatemanageUser.data = null;
      manageUser.updatemanageUser.loading = false;
      manageUser.updatemanageUser.error = action.payload;
    },
    deletemanageUserRequest: (manageUser, action) => {
      manageUser.deletemanageUser.loading = true;
      manageUser.deletemanageUser.error = null;
    },
    deletemanageUserSuccess: (manageUser, action) => {
      manageUser.deletemanageUser.loading = false;
      manageUser.deletemanageUser.error = null;
      manageUser.deletemanageUser.data = action.payload;
    },
    deletemanageUserFaliure: (manageUser, action) => {
      manageUser.deletemanageUser.data = null;
      manageUser.deletemanageUser.loading = false;
      manageUser.deletemanageUser.error = action.payload;
    },
    updatemanageUserDetailsRequest: (manageUser, action) => {
      manageUser.updatemanageUserDetails.loading = true;
      manageUser.updatemanageUserDetails.error = null;
    },
    updatemanageUserDetailsSuccess: (manageUser, action) => {
      manageUser.updatemanageUserDetails.loading = false;
      manageUser.updatemanageUserDetails.error = null;
      manageUser.updatemanageUserDetails.data = action.payload;
      manageUser.manageUserList = updatemangeuserDetails(
        action.payload,
        manageUser.manageUserList
      );
    },
    updatemanageUserDetailsFaliure: (manageUser, action) => {
      manageUser.updatemanageUserDetails.data = null;
      manageUser.updatemanageUserDetails.loading = false;
      manageUser.updatemanageUserDetails.error = action.payload;
    },
    getUserDetailsRequest: (manageUser, action) => {
      manageUser.getUserDetails.loading = true;
      manageUser.getUserDetails.error = null;
    },
    getUserDetailsSuccess: (manageUser, action) => {
      manageUser.getUserDetails.loading = false;
      manageUser.getUserDetails.error = null;
      manageUser.getUserDetails.data = action.payload;
    },
    getUserDetailsFaliure: (manageUser, action) => {
      manageUser.getUserDetails.data = null;
      manageUser.getUserDetails.loading = false;
      manageUser.getUserDetails.error = action.payload;
    },
    getUserDetailsReset:(manageUser, action) => {
     manageUser.updatemanageUserDetails =initialState.updatemanageUserDetails
    },
    fetchUsersByRoleRequest: (manageUser, action) => {
      manageUser.usersByRoleList.loading = true;
      manageUser.usersByRoleList.error = null;
    },
    fetchUsersByRoleSuccess: (manageUser, action) => {
      manageUser.usersByRoleList.data = action.payload;
      manageUser.usersByRoleList.loading = false;
      manageUser.usersByRoleList.error = null;
    },
    fetchUsersByRoleFailure: (manageUser, action) => {
      manageUser.usersByRoleList.data = null;
      manageUser.usersByRoleList.loading = false;
      manageUser.usersByRoleList.error = action.payload;
    },
  },
});
function updatemangeuserDetails(dataToUpdate, state) {
  let value = JSON.parse(JSON.stringify(state.data.data, undefined, 1));
  let filteredObject = value.map((e) => e._id);
  let obj = filteredObject.indexOf(dataToUpdate.data._id);
  if (obj !== -1) {
    value[obj] = dataToUpdate.data;
  }
  let finlaValue = { loading: false, error: false, data: { data: value } };
  return finlaValue;
}
function addNewUserSuccess(dataToUpdate, state) {
  state.data.data = [dataToUpdate,...state.data.data];
  state.data.total++;
  return state;
}
function updateUserSuccess(dataToUpdate, state) {
  state.data.data = state.data.data.map((value) => {
    if (value._id !== dataToUpdate._id) return value;
    return { ...value, ...dataToUpdate };
  });

  return state;
}
export const {
  fetchmanageUserRequest,
  fetchmanageUserSuccess,
  fetchmanageUserFailure,
  createmanageUserRequest,
  createmanageUserSuccess,
  createmanageUserFailure,
  updatemanageUserRequest,
  updatemanageUserSuccess,
  updatemanageUserFaliure,
  deletemanageUserRequest,
  deletemanageUserSuccess,
  deletemanageUserFaliure,
  updatemanageUserDetailsRequest,
  updatemanageUserDetailsSuccess,
  updatemanageUserDetailsFaliure,
  getUserDetailsRequest,
  getUserDetailsSuccess,
  getUserDetailsFaliure,
  getUserDetailsReset,
  fetchUsersByRoleRequest,
  fetchUsersByRoleSuccess,
  fetchUsersByRoleFailure,
} = manageUser.actions;

export const getmanageUserListState = (store) =>
  store.manageUser?.manageUserList;
export const getmanageUserCreateState = (store) =>
  store.manageUser?.createmanageUser;
export const getUserDetailData = (store) => store.manageUser?.getUserDetails;
export const getUpdatemanageUserDetailsState = (store) =>
  store.manageUser?.updatemanageUserDetails;
  export const fetchUsersByRoleState = (store) =>
  store.manageUser?.usersByRoleList;
export default manageUser.reducer;
